import { TApplicationState } from '../../types/redux';

export function getSalesStartHousesString(state: TApplicationState): string {
  return state.newbuilding.salesStartHousesString || '';
}
